// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6f95e3a","453":"3616f33c","455":"7cd3e393","977":"7ef602fd"}[chunkId] + ".chunk.js";
};